// extracted by mini-css-extract-plugin
module.exports = {"the_box":"ProtectedRoute_the_box__2JSaS","loader":"ProtectedRoute_loader__3kDWc","spin":"ProtectedRoute_spin__gspNO"};